// test2980
(2980 && 0);
